<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<el-tabs v-model="activeName" type="card" >
					<el-tab-pane label="物流" name="express">
						<div style="position: relative;width: 100%;height: 650px;">
							<expressIndex :data="data" ref="expressIndex" />
						</div>
					</el-tab-pane>
				</el-tabs>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="保存" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import expressIndex from './express.vue'
	export default {
		mixins: [modalMixins],
		props: {
			row: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '供应商配置',
				modal_model: false,
				modal_width: 1200,
				modal_height: 800,
				activeName: 'express',
				loading:false,
				data:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init(){
				this.list()
			},
			list(){
				this.loading = true
				this.$api.supplierconfig.list().then((res)=>{
					this.loading = false
					this.data = res
					//console.log(res)
					this.$nextTick(()=>{
						this.$refs.expressIndex.getgrid().commitProxy('query')
					})
				},()=>{
					this.loading = false
				})
			},
			submit() {
				this.loading = true
				let express = this.$refs.expressIndex.submit()
				this.$api.supplierconfig.save({
					express:express
				}).then(()=>{
					this.loading = false
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
				//console.log(express)
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			expressIndex
		}
	}
</script>